import './style.css'
import { useRef, useState } from 'react'
import { RxHamburgerMenu } from 'react-icons/rx'
import { FiPrinter, FiDownload } from 'react-icons/fi'
import { BeatLoader } from 'react-spinners'

import Sidebar from '../../../components/Common/Sidebar/Sidebar'
import AdminProfile from '../../../components/AdminProfile/AdminProfile'
import MobileSideBar from '../../../components/MobileSideBar/MobileSideBar'
import Pagination from '../../../components/Pagination/Pagination'

import StatsCards from './components/StatsCards'
import OrderFilters from './components/OrderFilters'
import OrdersTable from './components/OrdersTable'
import OrderDetailModal from './components/OrderDetailModal'
import { useCustomSaddleOrders } from './useCustomSaddleOrders'
import { exportOrdersToCSV } from './exportUtils'

function CustomSaddleOrders() {
    const [isProfileOpen, setIsProfileOpen] = useState(false)
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false)
    const printRef = useRef(null)

    const {
        isCactusAdmin,
        isSaddlefitAdmin,

        // Data
        orders,
        loading,
        error,
        stats,

        // Filters
        statusFilter,
        shippingFilter,
        statusOptions,
        handleStatusFilterChange,
        handleShippingFilterChange,

        // Pagination
        canLoadNext,
        canLoadPrevious,
        loadNextPage,
        loadPreviousPage,

        // Modal
        selectedOrder,
        isDetailModalOpen,
        isEditMode,
        setIsEditMode,
        editStatus,
        setEditStatus,
        editNotes,
        setEditNotes,
        handleViewOrder,
        handleUpdateOrder,
        closeDetailModal,
        updateLoading,
    } = useCustomSaddleOrders()

    // Loading state
    if (loading && !orders.length) {
        return (
            <div className="custom-saddle-orders-page">
                <Sidebar />
                <div className="custom-saddle-orders-content">
                    <div className="flex items-center justify-center h-[60vh]">
                        <BeatLoader color={'#2b364b'} />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="custom-saddle-orders-page">
            <Sidebar />

            <div className="custom-saddle-orders-content">
                {/* Header */}
                <div className="flex justify-between items-center mb-6">
                    <div className="xl:hidden" onClick={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)}>
                        <RxHamburgerMenu className="w-6 h-6 cursor-pointer" />
                    </div>
                    {isMobileSidebarOpen && (
                        <MobileSideBar toggle={isMobileSidebarOpen} setToggle={setIsMobileSidebarOpen} />
                    )}
                    <AdminProfile setIsOpen={setIsProfileOpen} isOpen={isProfileOpen} />
                </div>

                {/* Page Title */}
                <div className="page-header">
                    <div>
                        <h1 className="page-title">Custom Saddle Orders</h1>
                        <p className="page-subtitle">Manage custom saddle order requests</p>
                    </div>
                    <div className="flex gap-3">
                        <button onClick={() => exportOrdersToCSV(orders)} className="export-btn">
                            <FiDownload size={18} />
                            Export CSV
                        </button>
                        <button onClick={() => window.print()} className="export-btn">
                            <FiPrinter size={18} />
                            Print
                        </button>
                    </div>
                </div>

                {/* Stats Cards */}
                <StatsCards stats={stats} isCactusAdmin={isCactusAdmin} />

                {/* Filters */}
                <OrderFilters
                    isCactusAdmin={isCactusAdmin}
                    isSaddlefitAdmin={isSaddlefitAdmin}
                    statusFilter={statusFilter}
                    shippingFilter={shippingFilter}
                    statusOptions={statusOptions}
                    onStatusFilterChange={handleStatusFilterChange}
                    onShippingFilterChange={handleShippingFilterChange}
                />

                {/* Orders Table */}
                <OrdersTable
                    orders={orders}
                    isCactusAdmin={isCactusAdmin}
                    statusFilter={statusFilter}
                    shippingFilter={shippingFilter}
                    error={error}
                    onViewOrder={handleViewOrder}
                />

                {/* Pagination */}
                {orders.length > 0 && (
                    <Pagination
                        loadNextPage={loadNextPage}
                        loadPreviousPage={loadPreviousPage}
                        canLoadNext={canLoadNext}
                        canLoadPrevious={canLoadPrevious}
                    />
                )}
            </div>

            {/* Order Detail Modal */}
            {isDetailModalOpen && selectedOrder && (
                <OrderDetailModal
                    order={selectedOrder}
                    isEditMode={isEditMode}
                    setIsEditMode={setIsEditMode}
                    editStatus={editStatus}
                    setEditStatus={setEditStatus}
                    editNotes={editNotes}
                    setEditNotes={setEditNotes}
                    onClose={closeDetailModal}
                    onUpdate={handleUpdateOrder}
                    updateLoading={updateLoading}
                    statusOptions={statusOptions}
                    printRef={printRef}
                    isCactusAdmin={isCactusAdmin}
                />
            )}
        </div>
    )
}

export default CustomSaddleOrders
